import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/dashboard/_base/produtos/editar/$id")({
  component: Outlet,
  params: {
    parse: (val) => ({ id: +val.id })
  }
});
